// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f8fafc;
  color: #1a202c;
  line-height: 1.55;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Import Inter font */

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Clean Card Effect */
.glass-effect {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 0.75rem;
}

/* Removed cyber-grid background pattern */

/* Utility classes */
.min-h-screen { min-height: 100vh; }
.bg-gray-50 { background-color: transparent; }
.bg-white { background-color: rgba(255, 255, 255, 0.95); backdrop-filter: blur(20px); }
.bg-blue-600 { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.bg-green-600 { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }
.bg-red-600 { background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%); }
.bg-yellow-600 { background: linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%); }
.bg-purple-600 { background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%); }
.bg-indigo-600 { background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%); }

.text-white { color: #ffffff; }
.text-gray-500 { color: #6b7280; }
.text-gray-600 { color: #4b5563; }
.text-gray-700 { color: #374151; }
.text-gray-900 { color: #111827; }
.text-blue-600 { color: #2563eb; }
.text-green-600 { color: #16a34a; }
.text-red-600 { color: #dc2626; }
.text-yellow-600 { color: #d97706; }
.text-purple-600 { color: #9333ea; }
.text-indigo-600 { color: #4f46e5; }

.border { border: 1px solid #e5e7eb; }
.border-gray-200 { border-color: #e5e7eb; }
.border-gray-300 { border-color: #d1d5db; }
.rounded { border-radius: 0.375rem; }
.rounded-md { border-radius: 0.375rem; }
.rounded-lg { border-radius: 0.5rem; }
.shadow { box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); }
.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }

.p-2 { padding: 0.5rem; }
.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.p-6 { padding: 1.5rem; }
.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
.px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }
.px-4 { padding-left: 1rem; padding-right: 1rem; }
.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }

.m-2 { margin: 0.5rem; }
.m-4 { margin: 1rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-4 { margin-bottom: 1rem; }
.mr-2 { margin-right: 0.5rem; }
.mr-3 { margin-right: 0.75rem; }
.ml-2 { margin-left: 0.5rem; }
.ml-4 { margin-left: 1rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-4 { margin-top: 1rem; }

.flex { display: flex; }
.inline-flex { display: inline-flex; }
.grid { display: grid; }
.hidden { display: none; }
.block { display: block; }
.inline-block { display: inline-block; }

.items-center { align-items: center; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }
.space-x-2 > * + * { margin-left: 0.5rem; }
.space-x-4 > * + * { margin-left: 1rem; }
.space-y-2 > * + * { margin-top: 0.5rem; }
.space-y-4 > * + * { margin-top: 1rem; }

.w-full { width: 100%; }
.h-4 { height: 1rem; }
.h-5 { height: 1.25rem; }
.h-6 { height: 1.5rem; }
.h-8 { height: 2rem; }
.w-4 { width: 1rem; }
.w-5 { width: 1.25rem; }
.w-6 { width: 1.5rem; }
.w-8 { width: 2rem; }

.text-xs { font-size: 0.75rem; }
.text-sm { font-size: 0.875rem; }
.text-base { font-size: 1rem; }
.text-lg { font-size: 1.125rem; }
.text-xl { font-size: 1.25rem; }
.text-2xl { font-size: 1.5rem; }

.font-medium { font-weight: 500; }
.font-semibold { font-weight: 600; }
.font-bold { font-weight: 700; }

.cursor-pointer { cursor: pointer; }
.hover\\:bg-gray-50:hover { background-color: #f9fafb; }
.hover\\:bg-gray-100:hover { background-color: #f3f4f6; }
.hover\\:bg-blue-700:hover { background-color: #1d4ed8; }

.disabled\\:opacity-50:disabled { opacity: 0.5; }

/* Grid layouts */
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }

@media (min-width: 768px) {
  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .md\\:flex-row { flex-direction: row; }
  .md\\:space-x-4 > * + * { margin-left: 1rem; margin-top: 0; }
  .md\\:space-y-0 > * + * { margin-top: 0; }
}

/* Override for license table spacing */
.mr-16 { margin-right: 4rem !important; }

@media (min-width: 1024px) {
  .lg\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\\:px-8 { padding-left: 2rem; padding-right: 2rem; }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Loading animation */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Status indicators */
.status-active {
  background-color: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.status-expired {
  background-color: #fef2f2;
  color: #dc2626;
  border-color: #fecaca;
}

.status-revoked {
  background-color: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}

.status-paused {
  background-color: #fefce8;
  color: #d97706;
  border-color: #fde68a;
}

.status-deleted {
  background-color: #f3f4f6;
  color: #9ca3af;
  border-color: #e5e7eb;
}

/* Button styles */
.btn {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background-color: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
}

.btn-primary:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

.btn-secondary {
  background-color: #ffffff;
  color: #374151;
  border-color: #d1d5db;
}

.btn-secondary:hover {
  background-color: #f9fafb;
}

.btn-danger {
  background-color: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
}

.btn-danger:hover {
  background-color: #b91c1c;
  border-color: #b91c1c;
}

/* Form styles */
.form-input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  background-color: #ffffff;
}

.form-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
}

/* Table styles */
.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem 1.5rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.table th {
  background-color: #f9fafb;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
}

.table tbody tr:hover {
  background-color: #f9fafb;
}

/* Badge styles */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.badge-active {
  background-color: #dcfce7;
  color: #166534;
}

.badge-expired {
  background-color: #fef2f2;
  color: #dc2626;
}

.badge-revoked {
  background-color: #f3f4f6;
  color: #374151;
}

.badge-paused {
  background-color: #fefce8;
  color: #d97706;
}

.badge-deleted {
  background-color: #f3f4f6;
  color: #9ca3af;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.modal-content {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 56rem;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

/* Premium Components */
.premium-btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.premium-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
}

.premium-btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  font-weight: 500;
  font-size: 0.875rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.premium-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.premium-search {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  color: white;
  placeholder-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  width: 300px;
  transition: all 0.3s ease;
}

.premium-search:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
}

.premium-search::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.premium-tab {
  flex: 1 1;
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  space-x: 0.75rem;
  cursor: pointer;
  border: none;
  background: transparent;
}

.premium-tab-active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));
  color: #4c51bf;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);
  border: 1px solid rgba(102, 126, 234, 0.3);
}

.premium-tab-inactive {
  color: #6b7280;
  background: rgba(255, 255, 255, 0.5);
}

.premium-tab-inactive:hover {
  background: rgba(255, 255, 255, 0.7);
  color: #4c51bf;
  transform: translateY(-1px);
}

.premium-stats-card {
  transform: translateY(0);
  transition: all 0.3s ease;
}

.premium-stats-card:hover {
  transform: translateY(-5px);
}

.premium-action-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 1.5rem;
  padding: 2rem;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.premium-action-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  border-color: rgba(102, 126, 234, 0.3);
}

.premium-action-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.premium-action-card:hover::before {
  opacity: 1;
}

.premium-action-icon {
  width: 4rem;
  height: 4rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.premium-action-arrow {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  color: #667eea;
}

.premium-action-card:hover .premium-action-arrow {
  opacity: 1;
  transform: translateX(0);
}

.premium-info-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 1.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  position: relative;
  overflow: hidden;
}

.premium-info-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 6rem;
  height: 6rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border-radius: 50%;
  transform: translate(2rem, 2rem);
}

/* Animations */
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes pulse-glow {
  0%, 100% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.4); }
  50% { box-shadow: 0 0 30px rgba(102, 126, 234, 0.6); }
}

.float-animation {
  animation: float 6s ease-in-out infinite;
}

.pulse-glow {
  animation: pulse-glow 2s ease-in-out infinite;
}

/* Cyberpunk UI Components */
.cyber-btn-primary {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  padding: 1rem 2rem;
  border-radius: 0.75rem;
  font-weight: 700;
  font-size: 1rem;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 
    0 0 20px rgba(59, 130, 246, 0.5),
    0 10px 40px rgba(0, 0, 0, 0.3);
}

.cyber-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 0 30px rgba(59, 130, 246, 0.8),
    0 15px 50px rgba(0, 0, 0, 0.4);
}

.cyber-btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.cyber-btn-primary:hover::before {
  left: 100%;
}

.cyber-btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 600;
  font-size: 0.875rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(20px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.cyber-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
}

.cyber-search {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  padding: 0.875rem 1rem 0.875rem 3rem;
  color: white;
  backdrop-filter: blur(20px);
  width: 350px;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}

.cyber-search:focus {
  outline: none;
  background: rgba(0, 0, 0, 0.6);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 
    0 0 0 3px rgba(59, 130, 246, 0.1),
    0 0 20px rgba(59, 130, 246, 0.3);
}

.cyber-search::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.cyber-icon-btn {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(20px);
  position: relative;
}

.cyber-icon-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 15px rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
}

.cyber-tab {
  flex: 1 1;
  padding: 1.5rem 2rem;
  border-radius: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  border: none;
  background: transparent;
  position: relative;
  overflow: hidden;
}

.cyber-tab-active {
  background: linear-gradient(135deg, 
    rgba(59, 130, 246, 0.2) 0%,
    rgba(147, 51, 234, 0.2) 100%);
  color: white;
  box-shadow: 
    0 0 30px rgba(59, 130, 246, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.cyber-tab-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

.cyber-tab-inactive {
  color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.cyber-tab-inactive:hover {
  background: rgba(255, 255, 255, 0.05);
  color: white;
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.cyber-stats-card {
  position: relative;
  transform: translateY(0);
  transition: all 0.4s ease;
}

.cyber-stats-card:hover {
  transform: translateY(-10px) scale(1.02);
}

.cyber-command-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1.5rem;
  padding: 2rem;
  transition: all 0.4s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(20px);
}

.cyber-command-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(59, 130, 246, 0.3);
  box-shadow: 
    0 0 40px rgba(59, 130, 246, 0.2),
    0 20px 60px rgba(0, 0, 0, 0.3);
}

.cyber-command-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.cyber-command-card:hover::before {
  opacity: 1;
}

.cyber-command-icon {
  width: 5rem;
  height: 5rem;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(59, 130, 246, 0.2);
  transition: all 0.3s ease;
}

.cyber-command-card:hover .cyber-command-icon {
  box-shadow: 
    0 15px 40px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(59, 130, 246, 0.4);
}

.cyber-info-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1.5rem;
  padding: 2rem;
  backdrop-filter: blur(20px);
  position: relative;
  overflow: hidden;
}

.cyber-info-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 8rem;
  height: 8rem;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  transform: translate(3rem, 3rem);
}

/* Responsive utilities */
@media (max-width: 640px) {
  .sm\\:hidden { display: none; }
  .sm\\:block { display: block; }
  .sm\\:flex { display: flex; }
  .sm\\:text-sm { font-size: 0.875rem; }
  .sm\\:px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
  
  .premium-search {
    width: 200px;
  }
  
  .premium-action-card {
    padding: 1.5rem;
  }
  
  .premium-action-icon {
    width: 3rem;
    height: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;cAEY;EACZ,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;;AAGtB;EACE;aACW;AACb;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iFAAiF;EACjF,sBAAsB;AACxB;;AAEA,0CAA0C;;AAE1C,oBAAoB;AACpB,gBAAgB,iBAAiB,EAAE;AACnC,cAAc,6BAA6B,EAAE;AAC7C,YAAY,2CAA2C,EAAE,2BAA2B,EAAE;AACtF,eAAe,6DAA6D,EAAE;AAC9E,gBAAgB,6DAA6D,EAAE;AAC/E,cAAc,6DAA6D,EAAE;AAC7E,iBAAiB,6DAA6D,EAAE;AAChF,iBAAiB,6DAA6D,EAAE;AAChF,iBAAiB,6DAA6D,EAAE;;AAEhF,cAAc,cAAc,EAAE;AAC9B,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,kBAAkB,cAAc,EAAE;AAClC,gBAAgB,cAAc,EAAE;AAChC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;;AAEnC,UAAU,yBAAyB,EAAE;AACrC,mBAAmB,qBAAqB,EAAE;AAC1C,mBAAmB,qBAAqB,EAAE;AAC1C,WAAW,uBAAuB,EAAE;AACpC,cAAc,uBAAuB,EAAE;AACvC,cAAc,qBAAqB,EAAE;AACrC,UAAU,2EAA2E,EAAE;AACvF,aAAa,mFAAmF,EAAE;;AAElG,OAAO,eAAe,EAAE;AACxB,OAAO,gBAAgB,EAAE;AACzB,OAAO,aAAa,EAAE;AACtB,OAAO,eAAe,EAAE;AACxB,QAAQ,oBAAoB,EAAE,qBAAqB,EAAE;AACrD,QAAQ,qBAAqB,EAAE,sBAAsB,EAAE;AACvD,QAAQ,kBAAkB,EAAE,mBAAmB,EAAE;AACjD,QAAQ,oBAAoB,EAAE,qBAAqB,EAAE;AACrD,QAAQ,oBAAoB,EAAE,uBAAuB,EAAE;AACvD,QAAQ,mBAAmB,EAAE,sBAAsB,EAAE;AACrD,QAAQ,oBAAoB,EAAE,uBAAuB,EAAE;AACvD,QAAQ,iBAAiB,EAAE,oBAAoB,EAAE;;AAEjD,OAAO,cAAc,EAAE;AACvB,OAAO,YAAY,EAAE;AACrB,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,QAAQ,aAAa,EAAE;AACvB,UAAU,aAAa,EAAE;AACzB,SAAS,cAAc,EAAE;AACzB,gBAAgB,qBAAqB,EAAE;;AAEvC,gBAAgB,mBAAmB,EAAE;AACrC,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,8BAA8B,EAAE;AACnD,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,iBAAiB,EAAE;AACxC,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,gBAAgB,EAAE;;AAEvC,UAAU,WAAW,EAAE;AACvB,OAAO,YAAY,EAAE;AACrB,OAAO,eAAe,EAAE;AACxB,OAAO,cAAc,EAAE;AACvB,OAAO,YAAY,EAAE;AACrB,OAAO,WAAW,EAAE;AACpB,OAAO,cAAc,EAAE;AACvB,OAAO,aAAa,EAAE;AACtB,OAAO,WAAW,EAAE;;AAEpB,WAAW,kBAAkB,EAAE;AAC/B,WAAW,mBAAmB,EAAE;AAChC,aAAa,eAAe,EAAE;AAC9B,WAAW,mBAAmB,EAAE;AAChC,WAAW,kBAAkB,EAAE;AAC/B,YAAY,iBAAiB,EAAE;;AAE/B,eAAe,gBAAgB,EAAE;AACjC,iBAAiB,gBAAgB,EAAE;AACnC,aAAa,gBAAgB,EAAE;;AAE/B,kBAAkB,eAAe,EAAE;AACnC,2BAA2B,yBAAyB,EAAE;AACtD,4BAA4B,yBAAyB,EAAE;AACvD,4BAA4B,yBAAyB,EAAE;;AAEvD,iCAAiC,YAAY,EAAE;;AAE/C,iBAAiB;AACjB,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,SAAS,SAAS,EAAE;AACpB,SAAS,WAAW,EAAE;;AAEtB;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,yBAAyB,iBAAiB,EAAE,aAAa,EAAE;EAC3D,yBAAyB,aAAa,EAAE;AAC1C;;AAEA,uCAAuC;AACvC,SAAS,6BAA6B,EAAE;;AAExC;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;AACvD;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yDAAmP;EACnP,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qFAAqF;EACrF,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gDAAgD;EAChD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sFAAsF;EACtF,cAAc;EACd,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wFAAwF;EACxF,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,wFAAwF;EACxF,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB;;kCAEgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC;;oCAEkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;iCAE+B;EAC/B,YAAY;EACZ;;0CAEwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,qCAAqC;EACrC;;kCAEgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qFAAqF;EACrF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;oCAEkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;;oCAEkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,qBAAqB;EACrB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gFAAgF;EAChF,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,cAAc,aAAa,EAAE;EAC7B,aAAa,cAAc,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,eAAe,mBAAmB,EAAE;EACpC,YAAY,oBAAoB,EAAE,qBAAqB,EAAE;;EAEzD;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Reset and base styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  font-size: 15px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f8fafc;\n  color: #1a202c;\n  line-height: 1.55;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Import Inter font */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Clean Card Effect */\n.glass-effect {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border-radius: 0.75rem;\n}\n\n/* Removed cyber-grid background pattern */\n\n/* Utility classes */\n.min-h-screen { min-height: 100vh; }\n.bg-gray-50 { background-color: transparent; }\n.bg-white { background-color: rgba(255, 255, 255, 0.95); backdrop-filter: blur(20px); }\n.bg-blue-600 { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }\n.bg-green-600 { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }\n.bg-red-600 { background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%); }\n.bg-yellow-600 { background: linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%); }\n.bg-purple-600 { background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%); }\n.bg-indigo-600 { background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%); }\n\n.text-white { color: #ffffff; }\n.text-gray-500 { color: #6b7280; }\n.text-gray-600 { color: #4b5563; }\n.text-gray-700 { color: #374151; }\n.text-gray-900 { color: #111827; }\n.text-blue-600 { color: #2563eb; }\n.text-green-600 { color: #16a34a; }\n.text-red-600 { color: #dc2626; }\n.text-yellow-600 { color: #d97706; }\n.text-purple-600 { color: #9333ea; }\n.text-indigo-600 { color: #4f46e5; }\n\n.border { border: 1px solid #e5e7eb; }\n.border-gray-200 { border-color: #e5e7eb; }\n.border-gray-300 { border-color: #d1d5db; }\n.rounded { border-radius: 0.375rem; }\n.rounded-md { border-radius: 0.375rem; }\n.rounded-lg { border-radius: 0.5rem; }\n.shadow { box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); }\n.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }\n\n.p-2 { padding: 0.5rem; }\n.p-3 { padding: 0.75rem; }\n.p-4 { padding: 1rem; }\n.p-6 { padding: 1.5rem; }\n.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }\n.px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }\n.px-4 { padding-left: 1rem; padding-right: 1rem; }\n.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }\n.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }\n.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }\n.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }\n.py-4 { padding-top: 1rem; padding-bottom: 1rem; }\n\n.m-2 { margin: 0.5rem; }\n.m-4 { margin: 1rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-4 { margin-bottom: 1rem; }\n.mr-2 { margin-right: 0.5rem; }\n.mr-3 { margin-right: 0.75rem; }\n.ml-2 { margin-left: 0.5rem; }\n.ml-4 { margin-left: 1rem; }\n.mt-2 { margin-top: 0.5rem; }\n.mt-4 { margin-top: 1rem; }\n\n.flex { display: flex; }\n.inline-flex { display: inline-flex; }\n.grid { display: grid; }\n.hidden { display: none; }\n.block { display: block; }\n.inline-block { display: inline-block; }\n\n.items-center { align-items: center; }\n.justify-center { justify-content: center; }\n.justify-between { justify-content: space-between; }\n.space-x-2 > * + * { margin-left: 0.5rem; }\n.space-x-4 > * + * { margin-left: 1rem; }\n.space-y-2 > * + * { margin-top: 0.5rem; }\n.space-y-4 > * + * { margin-top: 1rem; }\n\n.w-full { width: 100%; }\n.h-4 { height: 1rem; }\n.h-5 { height: 1.25rem; }\n.h-6 { height: 1.5rem; }\n.h-8 { height: 2rem; }\n.w-4 { width: 1rem; }\n.w-5 { width: 1.25rem; }\n.w-6 { width: 1.5rem; }\n.w-8 { width: 2rem; }\n\n.text-xs { font-size: 0.75rem; }\n.text-sm { font-size: 0.875rem; }\n.text-base { font-size: 1rem; }\n.text-lg { font-size: 1.125rem; }\n.text-xl { font-size: 1.25rem; }\n.text-2xl { font-size: 1.5rem; }\n\n.font-medium { font-weight: 500; }\n.font-semibold { font-weight: 600; }\n.font-bold { font-weight: 700; }\n\n.cursor-pointer { cursor: pointer; }\n.hover\\:bg-gray-50:hover { background-color: #f9fafb; }\n.hover\\:bg-gray-100:hover { background-color: #f3f4f6; }\n.hover\\:bg-blue-700:hover { background-color: #1d4ed8; }\n\n.disabled\\:opacity-50:disabled { opacity: 0.5; }\n\n/* Grid layouts */\n.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n.gap-4 { gap: 1rem; }\n.gap-6 { gap: 1.5rem; }\n\n@media (min-width: 768px) {\n  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .md\\:flex-row { flex-direction: row; }\n  .md\\:space-x-4 > * + * { margin-left: 1rem; margin-top: 0; }\n  .md\\:space-y-0 > * + * { margin-top: 0; }\n}\n\n/* Override for license table spacing */\n.mr-16 { margin-right: 4rem !important; }\n\n@media (min-width: 1024px) {\n  .lg\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .lg\\:px-8 { padding-left: 2rem; padding-right: 2rem; }\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Loading animation */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Status indicators */\n.status-active {\n  background-color: #dcfce7;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.status-expired {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border-color: #fecaca;\n}\n\n.status-revoked {\n  background-color: #f3f4f6;\n  color: #374151;\n  border-color: #e5e7eb;\n}\n\n.status-paused {\n  background-color: #fefce8;\n  color: #d97706;\n  border-color: #fde68a;\n}\n\n.status-deleted {\n  background-color: #f3f4f6;\n  color: #9ca3af;\n  border-color: #e5e7eb;\n}\n\n/* Button styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary {\n  background-color: #2563eb;\n  color: #ffffff;\n  border-color: #2563eb;\n}\n\n.btn-primary:hover {\n  background-color: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n.btn-secondary {\n  background-color: #ffffff;\n  color: #374151;\n  border-color: #d1d5db;\n}\n\n.btn-secondary:hover {\n  background-color: #f9fafb;\n}\n\n.btn-danger {\n  background-color: #dc2626;\n  color: #ffffff;\n  border-color: #dc2626;\n}\n\n.btn-danger:hover {\n  background-color: #b91c1c;\n  border-color: #b91c1c;\n}\n\n/* Form styles */\n.form-input {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  background-color: #ffffff;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  background-color: #ffffff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 0.5rem center;\n  background-repeat: no-repeat;\n  background-size: 1.5em 1.5em;\n  padding-right: 2.5rem;\n}\n\n/* Table styles */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 0.75rem 1.5rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.table th {\n  background-color: #f9fafb;\n  font-weight: 500;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #6b7280;\n}\n\n.table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n/* Badge styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.625rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.badge-active {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.badge-expired {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n\n.badge-revoked {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.badge-paused {\n  background-color: #fefce8;\n  color: #d97706;\n}\n\n.badge-deleted {\n  background-color: #f3f4f6;\n  color: #9ca3af;\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n}\n\n.modal-content {\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  max-width: 56rem;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n/* Premium Components */\n.premium-btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 1rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.premium-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);\n}\n\n.premium-btn-secondary {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 0.75rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.premium-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.premium-search {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 1rem;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  color: white;\n  placeholder-color: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(10px);\n  width: 300px;\n  transition: all 0.3s ease;\n}\n\n.premium-search:focus {\n  outline: none;\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);\n}\n\n.premium-search::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.premium-tab {\n  flex: 1;\n  padding: 1rem 1.5rem;\n  border-radius: 1rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  space-x: 0.75rem;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n}\n\n.premium-tab-active {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));\n  color: #4c51bf;\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);\n  border: 1px solid rgba(102, 126, 234, 0.3);\n}\n\n.premium-tab-inactive {\n  color: #6b7280;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.premium-tab-inactive:hover {\n  background: rgba(255, 255, 255, 0.7);\n  color: #4c51bf;\n  transform: translateY(-1px);\n}\n\n.premium-stats-card {\n  transform: translateY(0);\n  transition: all 0.3s ease;\n}\n\n.premium-stats-card:hover {\n  transform: translateY(-5px);\n}\n\n.premium-action-card {\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8));\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.premium-action-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\n  border-color: rgba(102, 126, 234, 0.3);\n}\n\n.premium-action-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.premium-action-card:hover::before {\n  opacity: 1;\n}\n\n.premium-action-icon {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.premium-action-arrow {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  opacity: 0;\n  transform: translateX(-10px);\n  transition: all 0.3s ease;\n  color: #667eea;\n}\n\n.premium-action-card:hover .premium-action-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.premium-info-card {\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8));\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  position: relative;\n  overflow: hidden;\n}\n\n.premium-info-card::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 6rem;\n  height: 6rem;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));\n  border-radius: 50%;\n  transform: translate(2rem, 2rem);\n}\n\n/* Animations */\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n@keyframes pulse-glow {\n  0%, 100% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.4); }\n  50% { box-shadow: 0 0 30px rgba(102, 126, 234, 0.6); }\n}\n\n.float-animation {\n  animation: float 6s ease-in-out infinite;\n}\n\n.pulse-glow {\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n/* Cyberpunk UI Components */\n.cyber-btn-primary {\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 0.75rem;\n  font-weight: 700;\n  font-size: 1rem;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: \n    0 0 20px rgba(59, 130, 246, 0.5),\n    0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.cyber-btn-primary:hover {\n  transform: translateY(-3px);\n  box-shadow: \n    0 0 30px rgba(59, 130, 246, 0.8),\n    0 15px 50px rgba(0, 0, 0, 0.4);\n}\n\n.cyber-btn-primary::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left 0.5s;\n}\n\n.cyber-btn-primary:hover::before {\n  left: 100%;\n}\n\n.cyber-btn-secondary {\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.75rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(20px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.cyber-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(59, 130, 246, 0.5);\n  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);\n  transform: translateY(-2px);\n}\n\n.cyber-search {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 1rem;\n  padding: 0.875rem 1rem 0.875rem 3rem;\n  color: white;\n  backdrop-filter: blur(20px);\n  width: 350px;\n  transition: all 0.3s ease;\n  font-size: 0.875rem;\n}\n\n.cyber-search:focus {\n  outline: none;\n  background: rgba(0, 0, 0, 0.6);\n  border-color: rgba(59, 130, 246, 0.5);\n  box-shadow: \n    0 0 0 3px rgba(59, 130, 246, 0.1),\n    0 0 20px rgba(59, 130, 246, 0.3);\n}\n\n.cyber-search::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.cyber-icon-btn {\n  width: 2.75rem;\n  height: 2.75rem;\n  border-radius: 0.75rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(20px);\n  position: relative;\n}\n\n.cyber-icon-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(59, 130, 246, 0.5);\n  box-shadow: 0 0 15px rgba(59, 130, 246, 0.3);\n  transform: translateY(-2px);\n}\n\n.cyber-tab {\n  flex: 1;\n  padding: 1.5rem 2rem;\n  border-radius: 1rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  position: relative;\n  overflow: hidden;\n}\n\n.cyber-tab-active {\n  background: linear-gradient(135deg, \n    rgba(59, 130, 246, 0.2) 0%,\n    rgba(147, 51, 234, 0.2) 100%);\n  color: white;\n  box-shadow: \n    0 0 30px rgba(59, 130, 246, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.cyber-tab-active::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n.cyber-tab-inactive {\n  color: rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.cyber-tab-inactive:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n  border-color: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n.cyber-stats-card {\n  position: relative;\n  transform: translateY(0);\n  transition: all 0.4s ease;\n}\n\n.cyber-stats-card:hover {\n  transform: translateY(-10px) scale(1.02);\n}\n\n.cyber-command-card {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  transition: all 0.4s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  backdrop-filter: blur(20px);\n}\n\n.cyber-command-card:hover {\n  transform: translateY(-10px);\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(59, 130, 246, 0.3);\n  box-shadow: \n    0 0 40px rgba(59, 130, 246, 0.2),\n    0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.cyber-command-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.cyber-command-card:hover::before {\n  opacity: 1;\n}\n\n.cyber-command-icon {\n  width: 5rem;\n  height: 5rem;\n  border-radius: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.3),\n    0 0 20px rgba(59, 130, 246, 0.2);\n  transition: all 0.3s ease;\n}\n\n.cyber-command-card:hover .cyber-command-icon {\n  box-shadow: \n    0 15px 40px rgba(0, 0, 0, 0.4),\n    0 0 30px rgba(59, 130, 246, 0.4);\n}\n\n.cyber-info-card {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  backdrop-filter: blur(20px);\n  position: relative;\n  overflow: hidden;\n}\n\n.cyber-info-card::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 8rem;\n  height: 8rem;\n  background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  transform: translate(3rem, 3rem);\n}\n\n/* Responsive utilities */\n@media (max-width: 640px) {\n  .sm\\:hidden { display: none; }\n  .sm\\:block { display: block; }\n  .sm\\:flex { display: flex; }\n  .sm\\:text-sm { font-size: 0.875rem; }\n  .sm\\:px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }\n  \n  .premium-search {\n    width: 200px;\n  }\n  \n  .premium-action-card {\n    padding: 1.5rem;\n  }\n  \n  .premium-action-icon {\n    width: 3rem;\n    height: 3rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
